import {
  LitElement,
  html,
  css,
  classMap,
  ref,
  createRef,
  map,
  range,
  unsafeHTML,
  styles,
  paths,
  utils,
  t,
} from '@hh/global.js'
const { throttle } = utils

class HHCollectionCarousel extends LitElement {
  static properties = {
    carouselSpeed: {
      type: Number,
      attribute: 'carousel-speed',
    },
    autoplay: {
      type: String,
      attribute: 'autoplay',
    },
  }

  constructor() {
    super()
    this.carouselSpeed = 0
  }

  connectedCallback() {
    super.connectedCallback()
    this.handleCarousel()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  handleCarousel() {
    const splideExtension = window.splide.Extensions

    if (this.autoplay === 'true') {
      this.splide = new Splide('.js-collection-carousel-slider', {
        type: 'loop',
        autoplay: this.autoplay ? 'pause' : false,
        interval: this.carouselSpeed * 1000,
        intersection: {
          inView: {
            autoplay: true,
          },
        },
        arrows: true,
        pagination: true,
        mediaQuery: 'min',
      }).mount(splideExtension)
    } else {
      this.splide = new Splide('.js-collection-carousel-slider', {
        type: 'loop',
        arrows: true,
        pagination: true,
        mediaQuery: 'min',
      }).mount()
    }
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-collection-carousel', HHCollectionCarousel)